// extracted by mini-css-extract-plugin
export var bodySections = "_3x-8";
export var gray = "_3x-7";
export var green = "_3x-4";
export var iconContainer = "_3x-9";
export var iconWidgetContainer = "_3x-1";
export var phoneIcon = "_3x-2";
export var red = "_3x-5";
export var statusDot = "_3x-3";
export var widgetContainer = "_3x-0";
export var yellow = "_3x-6";